module.exports = __webpack_public_path__ + "static/pauserecording2-a5cbb7eedb6b1bdbfc0c69b60dd19d5d.png";